module.exports = __webpack_public_path__ + "img/nav_3.88e8c934.png";